import request from '@/axios/request.js'

// 查询项目清单列表
export function getInventoryPage (params) {
  return request({
    url: '/mall/getInventoryPage',
    method: 'get',
    params
  })
}
export function saveInventory (data) {
  return request({
    url: 'mall/saveInventory',
    method: 'post',
    data
  })
}

// 项目清单详情
export function detailBargain (id) {
  return request({
    url: `mall/bargain/detail/${id}`,
    method: 'get'
  })
}
// 新增询价
export function saveFindSourcePrice(data) {
  return request({
    url: 'mall/saveFindSourcePrice',
    method: 'post',
    data
  })
}
// 寻源询价单详情
export function getFindSourcePriceInfo(params) {
  return request({
    url: 'mall/getFindSourcePriceInfo',
    method: 'post',
    params
  })
}
export function testtest (data) {
  return request({
    url: 'bpm/User/GetEmployeePage?key=' + data.key + '&pageNum=' + data.pageNum + '&pageSize=' + data.pageSize,
    method: 'get'
  })
}
export function addUser (data) {
  return request({
    url: 'system/user/saveBpmUser',
    method: 'post',
    data
  })
}

export function getProjectInfoPage (params) {
  return request({
    url: 'mall/getProjectInfoPage',
    method: 'get',
    params
  })
}
// 查询清单详情
export function getInventoryDetail (id) {
  return request({
    url: 'mall/getInventoryDetail/' + id,
    method: 'get'
  })
}

// 删除清单
export function del (data) {
  return request({
    url: 'mall/delInventory',
    method: 'delete',
    data
  })
}
// 查询询价结果
export function getFindSourcePricePage (params) {
  return request({
    url: 'mall/getFindSourcePricePage',
    method: 'post',
    params
  })
}

// 查询商品分类
export function getCates (params) {
  return request({
    url: 'mall/category',
    method: 'get',
    params
  })
}

// 根据商品编号查询商品信息
export function getGoodsByCode(id) {
  return request({
    url: 'mall/yxStoreProductAttrValueByUnique/' + id,
    method: 'get'
  })
}
// 根据商品编号查询批量商品信息
export function getGoodsByCodeList(data) {
  return request({
    url: 'mall/yxStoreProductAttrValueByUniqueList',
    method: 'post',
    data
  })
}
// 快速下单接口
export function fastCreateOrder (data) {
  return request({
    url: 'mall/yxStoreOrder/fastCreateOrder',
    method: 'post',
    data
  })
}
// 新快速下单接口
export function fastCreateOrderNew (data) {
  return request({
    url: 'mall/yxStoreOrder/fastCreateOrderByResult',
    method: 'post',
    data
  })
}

// 保存快速下单缓存
export function saveOrUpdateCache (data) {
  return request({
    url: 'mall/fastCreateOrderCache/saveOrUpdateCache',
    method: 'post',
    data
  })
}

// 获取快速下单缓存
export function getFastCreateOrderCache(id) {
  return request({
    url: 'mall/fastCreateOrderCache/getFastCreateOrderCache/' + id,
    method: 'get'
  })
}
// 清除缓存,根据sku编码
export function clearCacheBySkuCode (data) {
  return request({
    url: 'mall/fastCreateOrderCache/clearCacheBySkuCode',
    method: 'put',
    data
  })
}
// 清除缓存,全部清除
export function clearAllCache (data) {
  return request({
    url: 'mall/fastCreateOrderCache/clearAllCache',
    method: 'put',
    data
  })
}

// 修改寻源询单审核状态
export function editFindSourcePriceStatus(data) {
  return request({
    url: 'mall/editFindSourcePriceStatus',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/noticedetail.js